import type { ApiResponse } from '../types';
import routes from '@/config/routes';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import type { ICourseClass } from '@/store/admin/types/types';
import type { AxiosResponse } from 'axios';

const getCourseClassByCourseId = (courseId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.courseClass.getClass}/${courseId}`);

const saveCourseClass = async (courseClass: ICourseClass): Promise<AxiosResponse> =>
  await v3Post(routes.backendUrl.courseClass.saveClass, courseClass);

export const courseClassApi = {
  getCourseClassByCourseId,
  saveCourseClass,
};
